import { createContext } from 'react';

export const ScopesContext = createContext({
  scopes: [] as any,
  selectedScope: {} as any,
  setScopes: (scopes: any) => {},
  setSelectedScope: (selectedScope: any) => {},
});
